
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","transform":"translate(2.5 10.5)"}},[_c('circle',{attrs:{"cx":"9.5","cy":"1.5","r":"1.5"}}),_c('circle',{attrs:{"cx":"17.5","cy":"1.5","r":"1.5"}}),_c('circle',{attrs:{"cx":"1.5","cy":"1.5","r":"1.5"}})])])
          )
        }
      }
    